import React, { ChangeEvent } from 'react';
import { Form } from 'react-bootstrap';

interface Props {
  onChange: (event: ChangeEvent<HTMLSelectElement>) => void;
  value: string;
  id?: string;
  name: string;
  required?: boolean;
  disabled?: boolean;
}

/**
 * @description Ecosystem name select form component.
 * @param {Props} props
 * @return {JSX.Element}
 */
const EcosystemNameSelect = (props: Props): JSX.Element => {
  const name = props.name ?? 'ecosystemName';
  const required = props.required ?? false;
  return (
    <Form.Select
      id={props.id}
      value={props.value}
      name={name}
      required={required}
      disabled={!!props.disabled}
      onChange={props.onChange}
    >
      <option value={''}>Select an ecosystem</option>
      <option value="British Columbia">British Columbia</option>
      <option value="Alberta">Alberta</option>
      <option value="East Coast">East Coast</option>
      <option value="Quebec">Quebec</option>
      <option value="Other">Other</option>
      <option value="Ottawa">Ottawa</option>
      <option value="Toronto">Toronto</option>
      <option value="Waterloo Region">Waterloo Region</option>
    </Form.Select>
  );
};

export default EcosystemNameSelect;
